<template>
  <div justify="center">
    <v-dialog v-model="dialog" persistent  max-width="450px">      
      <v-card>                
        <v-card-title style="color: #00aeef; padding-bottom:5px">
          <h3>información</h3><hr>
        </v-card-title>
        <v-card-text style="vertical-align: top; padding-top:-5px; text-align: center; font-weight: bold;">
          <p>Estimado {{nameFull}} comuníquese con el ejecutivo comercial que está a cargo de su cuenta (PLA)</p>
        </v-card-text>
        <v-divider style="margin:0px"></v-divider>     
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" small text @click="reloadPage()">Cerrar</v-btn>                    
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

  export default {    
        
    mounted() {
      console.log(this.name)
    },

    data () {
      return {        
        dialog: false, 
        nameFull: '',    
      }
    },

     methods: {

      openDialog(name){      
        this.nameFull = name;
            this.dialog=true;
      },

      reloadPage(){
        this.dialog = false;
        window.location.reload();
      }
            
    }
  }
</script>
<style>

</style>